import { Injectable } from '@angular/core';

import { OrderItem, OrderType } from './models';

/**
 * Here are 2 examples:
 * Single order: ArtemisOrder.order([3,2,1,4], 'desc') => [4,3,2,1]
 * Muliple order:
 * arr = [[{ name: 'a', age: 1, score: 8 }, { name: 'b', age: 3, score: 7 }, { name: 'c', age: 2, score: 8 }];
 * OrderItems = [{value: 'age', type: 'desc'}, {value: 'score', type: 'desc'}];
 * ArtemisOrder.order(arr, OrderItems)
 * Results: [ { name: 'c', age: 2, score: 8 }, { name: 'a', age: 1, score: 8 }, { name: 'b', age: 3, score: 7 }];
 */

@Injectable()
export class ArtemisOrder {
  static order(objArr: any[], attArr: string | OrderItem[]): any[] {
    // If attrArr is null or undifined
    if (!objArr) {
      return;
    }
    // If attrArr typeof 'string'
    if (attArr && typeof attArr === 'string') {
      if (attArr === OrderType.ASC) {
        objArr.sort((a, b) => a - b);
      } else {
        objArr.sort((a, b) => b - a);
      }
    } else if (attArr && attArr.length > 0 && isTypeOfOrderItem(attArr)) {
      (<OrderItem[]>attArr).forEach((item: OrderItem) => {
        if (item.type === OrderType.ASC) {
          objArr.sort((a, b) => a[item.value] - b[item.value]);
        } else {
          objArr.sort((a, b) => b[item.value] - a[item.value]);
        }
      });
    }
    return objArr;
  }
}

function isTypeOfOrderItem(arr: any): boolean {
  if (arr[0]
    && arr[0].value !== undefined
    && arr[0].type !== undefined) {
      return true;
  }
  return false;
}
